const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 514.09 614.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 514.02,
    y1: 341.8,
    x2: 413.12,
    y2: 341.8,
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344.39,
    y1: 2.5,
    x2: 0.06,
    y2: 2.5,
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.55,
    y1: 2.5,
    x2: 2.55,
    y2: 172.15,
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 341.82,
    y1: 341.8,
    x2: 341.82,
    y2: 169.98,
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    y1: 341.8,
    x2: 344.32,
    y2: 341.8,
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 172.21,
    y1: 172.15,
    x2: 172.21,
    y2: 511.44,
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 169.69,
    y1: 511.44,
    x2: 514.02,
    y2: 511.44,
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 511.51,
    y1: 511.61,
    x2: 511.51,
    y2: 341.63,
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.04,
    y1: 172.15,
    x2: 514.09,
    y2: 172.15,
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 511.51,
    y1: 614.82,
    x2: 511.51,
    y2: 513.92,
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.933fde673e825e1ffc98b6f4280f03fc.svg";
export { ForwardRef as ReactComponent };